<template>
	<managing-box class="review-analysis-result" title="분석결과">
		<ul>
			<li class="review-analysis-result__item">
				<p class="review-analysis-result__title">긍정어</p>
				<div>
					<span v-if="!positiveDictItems.length"
						>데이터가 없습니다.</span
					>
					<p
						class="review-analysis-result__value"
						v-for="(item, idx) in positiveDictItems"
						:key="idx"
					>
						{{ item.value
						}}{{ item.isLinked ? '[연결어]' : '[단어]' }}
					</p>
				</div>
			</li>
			<li class="review-analysis-result__item">
				<p class="review-analysis-result__title">부정어</p>
				<div>
					<span v-if="!negativeDictItems.length"
						>데이터가 없습니다.</span
					>
					<p
						class="review-analysis-result__value"
						v-for="(item, idx) in negativeDictItems"
						:key="idx"
					>
						{{ item.value
						}}{{ item.isLinked ? '[연결어]' : '[단어]' }}
					</p>
				</div>
			</li>
			<li class="review-analysis-result__item">
				<p class="review-analysis-result__title">?</p>
				<div>
					<span v-if="!undefinedDictItems.length"
						>데이터가 없습니다.</span
					>
					<p
						class="review-analysis-result__value"
						v-for="(item, idx) in undefinedDictItems"
						:key="idx"
					>
						{{ item.value
						}}{{ item.isLinked ? '[연결어]' : '[단어]' }}
					</p>
				</div>
			</li>
			<li class="review-analysis-result__item">
				<p class="review-analysis-result__title">등록단어</p>
				<div>
					<span v-if="!customDictFromList.length"
						>데이터가 없습니다.</span
					>
					<p
						class="review-analysis-result__value"
						v-for="(item, idx) in customDictFromList"
						:key="idx"
					>
						{{ item }}
					</p>
				</div>
			</li>
			<li class="review-analysis-result__item">
				<p class="review-analysis-result__title">긍정어</p>
				<div>
					<span v-if="!positiveDictFromList.length"
						>데이터가 없습니다.</span
					>
					<p
						class="review-analysis-result__value"
						v-for="(list, idx) in positiveDictFromList"
						:key="idx"
					>
						<span
							class="review-analysis-result__text--linked"
							v-for="(item, idx) in list"
							:key="idx"
							>{{ item }}</span
						>
					</p>
				</div>
			</li>
			<li class="review-analysis-result__item">
				<p class="review-analysis-result__title">부정어</p>
				<div>
					<span v-if="!negativeDictFromList.length"
						>데이터가 없습니다.</span
					>
					<p
						class="review-analysis-result__value"
						v-for="(list, idx) in negativeDictFromList"
						:key="idx"
					>
						<span
							class="review-analysis-result__text--linked"
							v-for="(item, idx) in list"
							:key="idx"
							>{{ item }}</span
						>
					</p>
				</div>
			</li>
		</ul>
	</managing-box>
</template>

<script>
	import ManagingBox from '@/components/layout/ManagingBox.vue';

	export default {
		name: 'ReviewAnalysisResult',
		components: { ManagingBox },
		props: {
			positiveDictItems: { type: Array, default: [] },
			negativeDictItems: { type: Array, default: [] },
			undefinedDictItems: { type: Array, default: [] },
			customDictFromList: { type: Array, default: [] },
			positiveDictFromList: { type: Array, default: [] },
			negativeDictFromList: { type: Array, default: [] },
		},
	};
</script>

<style lang="scss">
	.review-analysis-result {
		position: relative;
		min-height: 49px;
		padding-left: 0;
		padding-top: 49px;
		border-right: 0;

		&:before {
			width: 100%;
			height: 49px;
			border-right: 0;
		}

		.box__header {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 49px;
			margin: 0;
			border-bottom: solid 1px #dfe6ee;
		}

		.box__conts {
			padding: 12px 8px;
		}
	}

	.review-analysis-result__item {
		padding-top: 14px;

		&:first-child {
			padding-top: 0;
		}
	}

	.review-analysis-result__title {
		line-height: 20px;
		font-size: 1rem;
		font-weight: 700;
	}

	.review-analysis-result__value {
		border-bottom: solid 1px #657088;
		line-height: 15px;
		margin-bottom: 4px;
	}

	.review-analysis-result__text--linked {
		&:before {
			content: ' + ';
			display: inline;
		}

		&:first-child::before {
			content: '';
			display: none;
		}
	}
</style>
